import React, { useEffect } from 'react';
import { Tab, Tabs } from '@mui/material';
import Modal from '@Shared.Angular/flowingly.components/Modal/Modal';
import TagList from '@Shared.Angular/flowingly.components/TagList/TagList';
import { useService } from '@Client/runner.hooks/useService';
import { SharedAngular } from '@Client/@types/sharedAngular';
import IFlowModelTag from '@Shared.Angular/@types/core/contracts/queryModel/tagGroup/flowModelTag';
import ITagGroupDetail from '@Shared.Angular/@types/core/contracts/queryModel/tagGroup/tagGroupDetail';
import { Guid } from '@Shared.Angular/@types/guid';

export type Props = {
  flowmodelId: Guid;
  openModal: boolean;
  onClose?: () => void;
};

const LibraryTag = ({ flowmodelId, openModal, onClose }: Props) => {
  const [flowModelTag, setFlowModelTag] = React.useState<IFlowModelTag>({
    flowModelName: '',
    tags: [],
    stepTags: []
  });

  const flowModelApiService = useService<SharedAngular.FlowModelApiService>(
    'flowModelApiService'
  );
  const [selectedTab, setSelectedTab] = React.useState(0);
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setSelectedTab(newValue);
  };

  useEffect(() => {
    if (openModal) {
      getTags();
    }
  }, [openModal]);

  const getTags = async () => {
    const response = await flowModelApiService.getTags(flowmodelId);
    setFlowModelTag(response);
  };

  const tagGroupsFormatted = (tagGroups: ITagGroupDetail[]) => {
    const result: Record<string, { tags: string[]; color: string }> = {};
    tagGroups.forEach((group) => {
      result[group.name] = {
        tags: group.tags.map((tag) => tag.name),
        color: group.color
      };
    });
    return result;
  };

  return (
    <Modal
      open={openModal}
      title={flowModelTag.flowModelName}
      onClose={onClose}
      onCancelClick={onClose}
      hideActionButton={true}
      cancelButtonText={'Close'}
    >
      <div className="library-tag-container">
        <div className="library-tag-tabs">
          <Tabs
            value={selectedTab}
            onChange={handleChange}
            textColor="primary"
            indicatorColor="primary"
            variant="fullWidth"
          >
            <Tab disableRipple label="Flow Model Tags" />
            <Tab disableRipple label="Step Tags" />
          </Tabs>
        </div>

        <div className="library-tag-content">
          {selectedTab === 0 && (
            <div>
              <TagList
                groupedSelectedTags={tagGroupsFormatted(flowModelTag.tags)}
              />
            </div>
          )}
          {selectedTab === 1 && (
            <div>
              {' '}
              <TagList
                groupedSelectedTags={tagGroupsFormatted(flowModelTag.stepTags)}
              />
            </div>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default LibraryTag;
